// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gdpr-block a {
  font-size: var(--main-font-size-links);
  text-decoration: underline;
}
.gdpr-block .pre-info {
  padding-bottom: 1rem;
  display: block;
}
.gdpr-block .gdpr-block-questions {
  background: var(--main-bg-color-darker);
  border: var(--main-border-width) solid var(--main-border-color);
  padding: 1rem;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
  margin-left: -5px;
  z-index: 2;
}
.gdpr-block .gdpr-block-questions:before {
  content: ' ';
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  border-color: transparent transparent var(--main-border-color) transparent;
  z-index: 1;
  top: calc(-2 + var(--main-border-width));
  left: 0;
}
.gdpr-block .gdpr-block-questions:after {
  content: ' ';
  position: absolute;
  border-width: 1rem;
  border-style: solid;
  border-color: transparent transparent var(--main-bg-color-darker) transparent;
  z-index: 1;
  top: -1.99rem;
  left: 0;
}
.gdpr-block .gdpr-block-questions:focus:before {
  border-color: transparent transparent var(--main-primary-color) transparent;
}
.gdpr-block .gdpr-block-questions:focus:after {
  border-color: transparent transparent var(--main-bg-color-darker) transparent;
  top: -1.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/GDPR/index.less"],"names":[],"mappings":"AAAA;EAEI,sCAAA;EACA,0BAAA;AAAJ;AAHA;EAOI,oBAAA;EACA,cAAA;AADJ;AAPA;EAYI,uCAAA;EACA,+DAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AAFJ;AAII;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0EAAA;EACA,UAAA;EACA,wCAAA;EACA,OAAA;AAFN;AAKI;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6EAAA;EACA,UAAA;EACA,aAAA;EACA,OAAA;AAHN;AAOM;EACE,2EAAA;AALR;AAQM;EACE,6EAAA;EACA,YAAA;AANR","sourcesContent":[".gdpr-block {\n  a {\n    font-size: var(--main-font-size-links);\n    text-decoration: underline;\n  }\n\n  .pre-info {\n    padding-bottom: 1rem;\n    display: block;\n  }\n\n  .gdpr-block-questions {\n    background: var(--main-bg-color-darker);\n    border: var(--main-border-width) solid var(--main-border-color);\n    padding: 1rem;\n    position: relative;\n    margin-top: .5rem;\n    margin-bottom: 2rem;\n    margin-left: -5px;\n    z-index: 2;\n\n    &:before {\n      content: ' ';\n      position: absolute;\n      border-width: 1rem;\n      border-style: solid;\n      border-color: transparent transparent var(--main-border-color) transparent;\n      z-index: 1;\n      top: calc(-2 + var(--main-border-width));\n      left: 0;\n    }\n\n    &:after {\n      content: ' ';\n      position: absolute;\n      border-width: 1rem;\n      border-style: solid;\n      border-color: transparent transparent var(--main-bg-color-darker) transparent;\n      z-index: 1;\n      top: -1.99rem;\n      left: 0;\n    }\n\n    &:focus {\n      &:before {\n        border-color: transparent transparent var(--main-primary-color) transparent;\n      }\n\n      &:after {\n        border-color: transparent transparent var(--main-bg-color-darker) transparent;\n        top: -1.90rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
